import classNames from 'classnames';
import React, { forwardRef } from 'react';

/** A wrapper-free input for controls whose surrounding UI owns the surface and focus state. */
const BareInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function BareInput({ className, ...props }, ref) {
    return (
      <input
        {...props}
        ref={ref}
        className={classNames(
          'min-w-0 border-0 bg-transparent text-default outline-none focus:outline-none',
          className,
        )}
      />
    );
  },
);

export default BareInput;
